var _defs, _rect, _path, _text, _path2, _text2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBackgroundWia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1581,
    height: 1903,
    viewBox: "0 0 1581 1903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.237,
    y1: -0.262,
    x2: -0.176,
    y2: 0.751,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#566cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8115",
    "data-name": "Group 8115",
    transform: "translate(-14105 11111)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1226",
    "data-name": "Rectangle 1226",
    width: 1581,
    height: 1903,
    transform: "translate(14105 -11111)",
    fill: "#f0f0f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8114",
    "data-name": "Group 8114",
    transform: "translate(14073.052 -10853.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8089",
    "data-name": "Group 8089",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 104.896, 182.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M78.162,14.508,71.524,55.553a17.2,17.2,0,0,1-23.663,13.17,28.681,28.681,0,0,0-6.786-1.976C22.391,63.726,4.287,79.541.644,102.075s8.549,43.251,27.235,46.272a28.791,28.791,0,0,0,6.569.3c11.327-.779,20.611,8.715,18.8,19.923l-6.433,39.777A17.259,17.259,0,0,0,61.1,228.144l40.713,6.584c11.132,1.8,21.3-7.41,19.954-18.606a28.7,28.7,0,0,1,.164-8.02c3.021-18.685,23.738-30.88,46.272-27.237s38.351,21.748,35.328,40.434a28.62,28.62,0,0,1-2.375,7.664c-4.8,10.2,1.941,22.147,13.073,23.946l40.713,6.584a17.259,17.259,0,0,0,19.794-14.284L306.082,51.37a17.261,17.261,0,0,0-14.283-19.8L97.958.224A17.261,17.261,0,0,0,78.162,14.508Z",
    transform: "translate(17.703 22.134)",
    fill: "#acaae2",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M78.162,14.508,71.524,55.552a17.2,17.2,0,0,1-23.663,13.17,28.679,28.679,0,0,0-6.785-1.976C22.391,63.726,4.287,79.541.644,102.075s8.549,43.251,27.235,46.272a28.79,28.79,0,0,0,6.569.3c11.327-.779,20.611,8.715,18.8,19.923l-6.433,39.777A17.259,17.259,0,0,0,61.1,228.144l40.713,6.584c11.132,1.8,21.3-7.41,19.954-18.606a28.7,28.7,0,0,1,.164-8.02c3.021-18.685,23.738-30.88,46.272-27.237s38.351,21.748,35.328,40.434a28.619,28.619,0,0,1-2.375,7.664c-4.8,10.2,1.941,22.147,13.073,23.946l40.713,6.584a17.259,17.259,0,0,0,19.794-14.283L306.082,51.37a17.261,17.261,0,0,0-14.283-19.8L97.958.224A17.261,17.261,0,0,0,78.162,14.508Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "HRm",
    transform: "translate(106.845 116.383) rotate(9)",
    fill: "#5066e7",
    fontSize: 57,
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HRM")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8090",
    "data-name": "Group 8090",
    transform: "translate(1564.072 568.181) rotate(166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M277.5,220.752a28.049,28.049,0,0,0-3.673-3.092c-9.732-6.847-11.523-20.463-3.111-28.875l24.65-24.65a19.277,19.277,0,0,0,0-27.265l-24.306-24.306a19.25,19.25,0,0,0-29.669,3.021,27.693,27.693,0,0,1-3.515,4.293c-12.994,12.994-36.23,10.827-51.9-4.844s-17.838-38.9-4.844-51.9a27.825,27.825,0,0,1,4.293-3.515,19.25,19.25,0,0,0,3.021-29.669L164.137,5.645a19.282,19.282,0,0,0-27.265,0L112.23,30.287c-8.42,8.422-6.624,22.049,3.117,28.9a27.937,27.937,0,0,1,3.679,3.095c12.994,13,10.827,36.23-4.844,51.9s-38.9,17.838-51.9,4.844a28.145,28.145,0,0,1-3.095-3.682c-6.85-9.741-20.48-11.536-28.9-3.114L5.647,136.87a19.277,19.277,0,0,0,0,27.265L136.872,295.359a19.277,19.277,0,0,0,27.265,0l24.647-24.647c8.414-8.414,22.03-6.621,28.878,3.108a27.83,27.83,0,0,0,3.092,3.674c12.994,12.994,36.23,10.827,51.9-4.844S290.49,233.745,277.5,220.752Z",
    transform: "translate(0 13.648)",
    fill: "#acaae2",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M277.5,220.752a28.067,28.067,0,0,0-3.673-3.092c-9.732-6.847-11.523-20.463-3.111-28.875l24.65-24.65a19.277,19.277,0,0,0,0-27.265l-24.306-24.306a19.25,19.25,0,0,0-29.669,3.021,27.689,27.689,0,0,1-3.515,4.293c-12.994,12.994-36.23,10.827-51.9-4.844s-17.838-38.9-4.844-51.9a27.821,27.821,0,0,1,4.293-3.515,19.25,19.25,0,0,0,3.021-29.669L164.137,5.645a19.282,19.282,0,0,0-27.265,0L112.23,30.287c-8.42,8.422-6.624,22.049,3.117,28.9a27.938,27.938,0,0,1,3.679,3.095c12.994,13,10.827,36.23-4.844,51.9s-38.9,17.838-51.9,4.844a28.135,28.135,0,0,1-3.095-3.682c-6.85-9.74-20.48-11.536-28.9-3.114L5.647,136.87a19.277,19.277,0,0,0,0,27.265L136.872,295.359a19.277,19.277,0,0,0,27.265,0l24.647-24.647c8.414-8.414,22.03-6.621,28.877,3.109a27.839,27.839,0,0,0,3.092,3.674c12.994,12.994,36.23,10.827,51.9-4.844S290.49,233.745,277.5,220.752Z",
    transform: "translate(32.751 0)",
    fill: "#fff"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "erp",
    transform: "translate(231.437 217.146) rotate(-135)",
    fill: "#16d696",
    fontSize: 55,
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CRM")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8110",
    "data-name": "Group 8110",
    transform: "translate(107.21 120.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8106",
    "data-name": "Group 8106",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 1263.648,
    height: 36.483,
    rx: 3.628,
    transform: "translate(0 949.191)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8102",
    "data-name": "Group 8102",
    transform: "translate(70.647 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8078",
    "data-name": "Group 8078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8071",
    "data-name": "Group 8071",
    transform: "translate(0 278.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7312",
    "data-name": "Path 7312",
    d: "M580.841,2023.85a17.892,17.892,0,0,0,17.848,17.831h965.149a17.892,17.892,0,0,0,17.849-17.831q3.955-290.648,7.909-581.3l-13.186-.4-19.422-.465-943.251-24.406H567.89S576.4,1821.551,580.841,2023.85Z",
    transform: "translate(-501.971 -1417.284)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7313",
    "data-name": "Path 7313",
    d: "M618.011,2056.37h960.066l7.374-560.945L637.89,1471.171c-8.653-.233-36.419,0-36.419,0Z",
    transform: "translate(-522.414 -1450.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8070",
    "data-name": "Group 8070",
    transform: "translate(719.688 47.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7314",
    "data-name": "Path 7314",
    d: "M3067.666,2241.256h-.037a2.473,2.473,0,0,1-2.438-2.512l.6-40.834a2.475,2.475,0,0,1,2.472-2.438h.025a2.475,2.475,0,0,1,2.45,2.512l-.6,40.834A2.475,2.475,0,0,1,3067.666,2241.256Z",
    transform: "translate(-2741.875 -1938.252)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7315",
    "data-name": "Path 7315",
    d: "M2566.1,1740.994h-.037a2.475,2.475,0,0,1-2.437-2.512l2.3-156.4c-.043-9.29-2.863-16.707-8.383-22-10.3-9.87-26.658-9.366-27.348-9.334l-288.945-7.748a2.473,2.473,0,0,1-2.407-2.539,2.369,2.369,0,0,1,2.541-2.406l288.772,7.748c1.8-.107,19.212-.408,30.81,10.7,6.523,6.251,9.857,14.865,9.907,25.594l-2.3,156.445A2.475,2.475,0,0,1,2566.1,1740.994Z",
    transform: "translate(-2238.838 -1538.055)",
    fill: "#0d37c9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7316",
    "data-name": "Path 7316",
    d: "M399.942,3054.763l1137.916.134v-48.653l-1137.916-.031s.021,1.816.043,48.759C399.984,3054.972,398.725,3054.763,399.942,3054.763Z",
    transform: "translate(-399.412 -2384.532)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8072",
    "data-name": "Group 8072",
    transform: "translate(181.704 67.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7317",
    "data-name": "Path 7317",
    d: "M1246.017,879.235c-208.283,6.461-375.816,170.016-381.73,372.99a8.056,8.056,0,0,0,8.136,8.175l363.568,1.2c12.531.041,22.674-9.907,22.54-22.108l-3.878-352.2A8.28,8.28,0,0,0,1246.017,879.235Z",
    transform: "translate(-864.103 -879.006)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7318",
    "data-name": "Path 7318",
    d: "M866.823,1905.933a2.958,2.958,0,0,0-3,2.913v.02c0,212.262,174.752,384.327,390.318,384.327h.042a4.05,4.05,0,0,0,4.081-4.062l-3.919-359.935a22.459,22.459,0,0,0-22.549-22.041Z",
    transform: "translate(-863.823 -1504.003)",
    fill: "#b1b6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7319",
    "data-name": "Path 7319",
    d: "M1898.923,1923.895l4,363.188a8.187,8.187,0,0,0,8.537,7.977c211.729-6.506,381.379-175.561,381.787-383.34l-1.116-1.094-378.409-1.254A14.557,14.557,0,0,0,1898.923,1923.895Z",
    transform: "translate(-1493.932 -1506.097)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7320",
    "data-name": "Path 7320",
    d: "M2262.4,1262.588a13.842,13.842,0,0,0,13.882-14.35c-7.747-205.425-176.718-369.581-384.035-369.581h0a4.1,4.1,0,0,0-4.094,4.139l3.9,363.427a15.322,15.322,0,0,0,15.269,15.158Z",
    transform: "translate(-1487.375 -878.657)",
    fill: "#b1b6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8073",
    "data-name": "Group 8073",
    transform: "translate(192.101 69.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7321",
    "data-name": "Path 7321",
    d: "M1262.535,883.766c-202.8,6.461-365.916,170.017-371.675,372.99a7.954,7.954,0,0,0,7.922,8.175l353.991,1.2a21.873,21.873,0,0,0,21.946-22.108l-3.776-352.2A8.156,8.156,0,0,0,1262.535,883.766Z",
    transform: "translate(-890.676 -883.538)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    "data-name": "Path 7322",
    d: "M893.35,1910.465a2.934,2.934,0,0,0-2.954,2.912v.03c0,212.252,172.065,384.316,384.316,384.316h.042a4.018,4.018,0,0,0,4.018-4.062l-3.859-359.935a22.28,22.28,0,0,0-22.2-22.04Z",
    transform: "translate(-890.396 -1508.535)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    "data-name": "Path 7323",
    d: "M1925.5,1928.427l3.894,363.189a8.069,8.069,0,0,0,8.318,7.977c206.293-6.506,371.586-175.561,371.983-383.34l-1.087-1.094-368.692-1.254A14.368,14.368,0,0,0,1925.5,1928.427Z",
    transform: "translate(-1520.505 -1510.629)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    "data-name": "Path 7324",
    d: "M2288.972,1267.12a13.842,13.842,0,0,0,13.882-14.349c-7.746-205.425-176.718-369.582-384.036-369.582h0a4.1,4.1,0,0,0-4.094,4.139l3.9,363.427a15.322,15.322,0,0,0,15.269,15.158Z",
    transform: "translate(-1513.948 -883.189)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M24.976,27.15V11.25h-7.95v15.9H1.125V35.1h15.9V51h7.95V35.1h15.9V27.15Z",
    transform: "translate(476.086 497.275)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8075",
    "data-name": "Group 8075",
    transform: "translate(342.554 558.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8074",
    "data-name": "Group 8074",
    transform: "translate(6.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M1253.974,2292.028l-33.546-.722v-47.271a2.79,2.79,0,0,1,2.895-2.789l28.609,1.058a2.12,2.12,0,0,1,2.042,2.119Z",
    transform: "translate(-1220.427 -2199.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M1374.71,2256.556l-33.547-.68v-71.4a2.189,2.189,0,0,1,2.282-2.187l29.278,1.249a2.074,2.074,0,0,1,1.987,2.073Z",
    transform: "translate(-1295.036 -2163.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M1494.048,2227.035l-32.149-.689v-90.452a2.95,2.95,0,0,1,3.1-2.946l26.667,1.356a2.509,2.509,0,0,1,2.382,2.506Z",
    transform: "translate(-1369.646 -2132.944)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M1337.67,2412.112l-134.13-1.95a1.428,1.428,0,0,1-1.405-1.427v-8.427a1.427,1.427,0,0,1,1.452-1.426l134.13,2.407a1.427,1.427,0,0,1,1.4,1.426v7.972A1.427,1.427,0,0,1,1337.67,2412.112Z",
    transform: "translate(-1202.134 -2297.279)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8076",
    "data-name": "Group 8076",
    transform: "translate(113.003 142.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M979.624,2502.846a6.14,6.14,0,0,1-1.3-.138c-53.349-11.41-109.026-46.229-156.773-98.041-48.03-52.122-81.9-114.955-95.371-176.927a6.166,6.166,0,1,1,12.051-2.619c13.012,59.861,45.823,120.657,92.39,171.188,46.032,49.955,99.4,83.458,150.282,94.34a6.167,6.167,0,0,1-1.283,12.2Z",
    transform: "translate(-711.249 -1770.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    "data-name": "Path 7330",
    d: "M688.233,2251.028l12.019-65.146a6.167,6.167,0,0,1,11.581-1.64c4.685,9.36,11.123,16.151,13.787,20.561,2.905,4.81,8.178,11.021,18.556,16.275l-6.894,10.226a108.038,108.038,0,0,1-20.964-18.4,106.882,106.882,0,0,1-6.9-8.741l-9.058,49.1Z",
    transform: "translate(-688.233 -1746.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M2890.724,1070.809",
    transform: "translate(-2028.984 -1070.809)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8077",
    "data-name": "Group 8077",
    transform: "translate(659.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7332",
    "data-name": "Path 7332",
    d: "M2390.393,903a6.164,6.164,0,0,1-5.386-3.155c-29.926-53.45-79.064-102.011-138.36-136.741-58.615-34.329-171.283-46.333-171.283-46.333l-1.054-12.287s117.773,12.369,178.571,47.979c61.157,35.82,111.9,86.022,142.887,141.357a6.168,6.168,0,0,1-5.375,9.179Z",
    transform: "translate(-2074.31 -704.486)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M2840.558,1135.92a6.165,6.165,0,0,1-4.47-1.917c-2.079-2.187-14.933-12.532-19.145-15.607a64.109,64.109,0,0,0-22.55-10.176q1.8-5.9,3.608-11.792a108.038,108.038,0,0,1,25.309,11.4,106.638,106.638,0,0,1,9.265,6.416l-5.676-49.6,12.252-1.4,7.533,65.816a6.167,6.167,0,0,1-6.126,6.867Z",
    transform: "translate(-2517.22 -923.487)",
    fill: "#16d696"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 146.605,
    height: 146.605,
    transform: "translate(314.466 226.106)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-videocam",
    "data-name": "Icon ionic-md-videocam",
    d: "M2263.579,1362.906v-37.137a9.783,9.783,0,0,0-8.59-10.592H2150.208a9.784,9.784,0,0,0-8.591,10.592v106.052a9.827,9.827,0,0,0,8.591,10.635h104.737a9.81,9.81,0,0,0,8.591-10.592v-37.138l33.271,42.412V1320.494Z",
    transform: "translate(-1459.943 -1076.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Box-2",
    "data-name": "Box",
    width: 162.861,
    height: 162.861,
    transform: "translate(306.338 217.978)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M1217.059,1362.443a64.578,64.578,0,1,1,64.577,64.578h-.07a64.539,64.539,0,0,1-64.507-64.571Zm12.916,0a51.662,51.662,0,1,0,51.662-51.662A51.662,51.662,0,0,0,1229.975,1362.443Zm45.2,6.458v-38.747h9.686v33.9l29.06,17.248-4.85,7.937Z",
    transform: "translate(-869.96 -1059.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_group_24px",
    "data-name": "ic group 24px",
    d: "M2246.573,2202.243a22.435,22.435,0,1,0-.2,0Zm-60.086,0a22.435,22.435,0,1,0-.2,0Zm0,15.021c-17.5,0-52.575,8.788-52.575,26.287v18.777h105.149v-18.777C2239.062,2226.052,2203.987,2217.264,2186.487,2217.264Zm60.086,0c-2.178,0-4.657.151-7.286.375a31.7,31.7,0,0,1,14.8,25.912v18.777h45.064v-18.777C2299.148,2226.052,2264.073,2217.264,2246.573,2217.264Z",
    transform: "translate(-1446.528 -1596.255)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8103",
    "data-name": "Group 8103",
    transform: "translate(185.026 568.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M762.708,2504.219s-109.988-43.89-158.83-94.67c-49.132-51.083-84.336-113.18-99.128-174.849a6.166,6.166,0,0,1,11.993-2.876c14.288,59.569,48.388,119.651,96.024,169.176,47.089,48.959,152.263,91.108,152.263,91.108Z",
    transform: "translate(-492.643 -2208.993)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M474.073,2251.028l12.019-65.146a6.167,6.167,0,0,1,11.58-1.64c4.685,9.36,11.123,16.151,13.787,20.561,2.905,4.81,8.178,11.021,18.556,16.275l-6.894,10.226a108.038,108.038,0,0,1-20.964-18.4,106.962,106.962,0,0,1-6.9-8.741l-9.058,49.1Z",
    transform: "translate(-474.073 -2180.836)",
    fill: "#0d37c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8083",
    "data-name": "Group 8083",
    transform: "translate(1166.056 505.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8082",
    "data-name": "Group 8082",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7334",
    "data-name": "Path 7334",
    d: "M2628.466,3179.355s-1.846,29.779-7.608,30.206c-.767.058-29.222.058-29.222.058l-36.322-.211s.238-8.753,10.856-10.6,28.388-9.312,34.82-23.346C2607.756,3160.7,2628.466,3179.355,2628.466,3179.355Z",
    transform: "translate(-2532.951 -2567.354)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8079",
    "data-name": "Group 8079",
    transform: "translate(51.04 109.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7335",
    "data-name": "Path 7335",
    d: "M2681.768,2357.974s-15.824,4.064-25.883,1.034-27.372,1.947-30.16,5.615-1.765,5.125,3.211,6.391,22.6,8.783,34.186,4.432,26.693-4.51,26.693-4.51Z",
    transform: "translate(-2624.202 -2202.875)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M2882.638,2003.031s-17.777,126.343-47.211,137.66c-14.525,5.583-78.713,18.241-97.7,19.513,0,0-4.653-3.773-3.519-19.133,0,0,67.25-24.69,76.8-38.117,14.219-19.983-8.827-81.637,9.014-100.405S2867.918,1975.716,2882.638,2003.031Z",
    transform: "translate(-2688.311 -1985.394)",
    fill: "#dd8e0a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7337",
    "data-name": "Path 7337",
    d: "M2961.952,2915.306V2887.76h43.369a2.133,2.133,0,0,0,2.127-2.128v-4.412a2.133,2.133,0,0,0-2.127-2.128h-43.369v-156.81a8.023,8.023,0,0,0-8-8h-8.583a8.024,8.024,0,0,0-8,8v156.81H2894a2.136,2.136,0,0,0-2.131,2.128v4.412a2.136,2.136,0,0,0,2.131,2.128h43.368v27.546c-31.379,2.373-56.519,13.668-63.572,28.265h151.726C3018.471,2928.975,2993.33,2917.679,2961.952,2915.306Z",
    transform: "translate(-2718.856 -2301.474)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7338",
    "data-name": "Path 7338",
    d: "M2825.881,2563.165a221.372,221.372,0,0,1-17.365,24.845c-19.1,24.118-39.9,44.005-43.525,62.8a85.337,85.337,0,0,1-3.359,12.032c-1.512,4.306-3.383,8.833-5.542,13.512-8.108,17.612-20.231,37.345-32.337,55.283-20.927,31.008-40.6,56.882-40.6,56.882l-36.087-1.538c1.444-3.617,17.185-46.431,38.24-98.753,8.551-21.241,17.642-43.834,26.414-65.622q1.752-4.364,3.494-8.68c2.682-6.668,5.321-13.232,7.9-19.623,19.771-49.129,35.517-88.251,35.517-88.251s79.018-29.933,87.224-10.537C2852.615,2511.513,2847.1,2527.18,2825.881,2563.165Z",
    transform: "translate(-2586.506 -2169.963)",
    fill: "#222a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7339",
    "data-name": "Path 7339",
    d: "M2905.284,2988.426s25.1,16.13,22.664,21.367c-.324.7-14.2,25.542-14.2,25.542l-17.893,31.612s-7.525-4.473-3.964-14.646,5.709-29.327-3.408-41.783C2878.895,2997.412,2905.284,2988.426,2905.284,2988.426Z",
    transform: "translate(-2726.206 -2461.498)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    d: "M2694.734,2495.872s-99.184,61.781-110.255,103.3,131.937,130.092,131.937,130.092,15.685-13.839,18.453-23.989c0,0-64.642-77.445-78.664-94.805-8.612-10.663,127.332-36.91,143.938-62.744s10.663-47.569,10.663-47.569Z",
    transform: "translate(-2549.619 -2173.985)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    d: "M17.733,0h182.29a17.731,17.731,0,0,1,17.731,17.731v19.9a17.731,17.731,0,0,1-17.731,17.731H17.733A17.733,17.733,0,0,1,0,37.628v-19.9A17.733,17.733,0,0,1,17.733,0Z",
    transform: "translate(121.927 401.221)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    "data-name": "Path 7341",
    d: "M2939.182,1904.359a55.978,55.978,0,0,0-15.109,13.692c23.761,6.146,63.152-15.872,63.152-15.872s-15.295-10.277-20.96-32.857q-.432-1.709-.779-3.5a71.284,71.284,0,0,1-1.287-12.364l-10.915,9.778-18.15,16.26a155.812,155.812,0,0,0,2.684,18.353Q2938.407,1900.885,2939.182,1904.359Z",
    transform: "translate(-2748.203 -1798.994)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    "data-name": "Path 7342",
    d: "M2964.6,2071.464c-3.4,45.777,2.32,115.37-1.541,127.427-3.332,10.4-42.545,4.246-57.7.771-5.61-1.284-12.405-3.121-19.422-5.292-19.573-6.062-40.9-14.715-43.189-21.14a5.559,5.559,0,0,1-.212-.74,5.876,5.876,0,0,1,.042-2.692c.764-3.274,3.7-6.819,4.049-14.926.387-9.054.329-19.715.669-31.179.018-1.291.035-2.7.176-3.983l.006-.469c.006-.247.012-.488.019-.733.328-12.786,1-26.227,1.772-39.558.492-8.372,1.061-16.662,1.718-24.606,1.707-20.506,4.008-38.741,7.051-50.271,4.976-18.792,15.948-31.05,25.935-40.033l7.223-6.195c8.061,1.759,17.59.592,26.208-3.491,9.329-4.43,12.55-7.6,14.175-6.408C2953.123,1964.568,2968.618,2015.5,2964.6,2071.464Z",
    transform: "translate(-2700.529 -1854.002)",
    fill: "#f09a0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M2886.4,2387.094c-19.573-6.061-40.9-14.715-43.188-21.14a5.168,5.168,0,0,1-.211-.739q.016-1.346.041-2.692c.762-3.274,3.7-6.818,4.048-14.926.388-9.054.329-19.715.669-31.179.018-1.292.035-2.7.176-3.984l.006-.469c.005-.247.011-.487.018-.733l73.933-33.532S2926.149,2337.287,2886.4,2387.094Z",
    transform: "translate(-2700.878 -2046.634)",
    fill: "#dd8e0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M2950.642,1893.205a156.119,156.119,0,0,0,2.682,18.352c17.723-5.725,25.764-21.734,28.449-28.524.763-1.918,1.095-3.1,1.095-3.1s-.688-.148-1.874-.4c-2.491-.53-7.182-1.525-12.2-2.586Z",
    transform: "translate(-2763.712 -1812.706)",
    fill: "#d998a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M2920.5,1824.8s38.938,4.392,41.3-19.9,8.978-40.084-15.783-43.915-30.5,4.967-33.261,12.883S2910.437,1823.031,2920.5,1824.8Z",
    transform: "translate(-2740.749 -1744.479)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M2959.073,1784.728s-2.468-32.244-37.912-35.584c-24.277-2.287-10.743-23.183-8.155-26.515,0,0,18.6,2.55,37.667,5.7C2990.69,1734.941,2963,1779.708,2959.073,1784.728Z",
    transform: "translate(-2738.186 -1722.629)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8080",
    "data-name": "Group 8080",
    transform: "translate(0 206.896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 3.584,
    height: 93.842,
    transform: "translate(0 1.107) rotate(-18.001)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 98.475,
    height: 5.891,
    transform: "translate(28.874 84.467) rotate(-1.224)",
    fill: "#0d37c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8081",
    "data-name": "Group 8081",
    transform: "translate(60.608 117.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M2703.33,2404.634s-15.281,5.785-25.613,3.881-26.99,4.953-29.356,8.906-1.189,5.288,3.895,6,23.433,6.238,34.466.637,26.034-7.425,26.034-7.425Z",
    transform: "translate(-2647.188 -2238.223)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M2886.65,2019.59s-3.74,127.533-31.747,142.025c-13.82,7.151-76.223,26.808-94.953,30.166,0,0-5.039-3.238-5.606-18.629,0,0,64.119-31.953,72.134-46.352,11.928-21.429-17.774-80.166-2.109-100.787S2869.009,1994.063,2886.65,2019.59Z",
    transform: "translate(-2709.737 -2004.878)",
    fill: "#f09a0a"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackgroundWia);
export default __webpack_public_path__ + "static/media/login-background-WIA.119a178402891ef826b2cc423e23332a.svg";
export { ForwardRef as ReactComponent };